import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import talentFinderApi from '../../../services/talentFinderApi';
import { PERMISSION } from '../../../utils/constants';
import TalentFinderExportOption from '../TalentFinderExportOption/TalentFinderExportOption';
import { TF_EXPORT_DEFAULT_SELECT_OPTIONS, TF_SORTED_OPTIONS } from '../TalentFinderExportOption/talent-finder-export.constants';
import { Spin } from 'antd';

const TalentExport = (props) => {
  const { filter, keyword, role, totalData, setShowExporting, talentSearchResult } = props;
  const permissions = useSelector((state) => state.user.permissions);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedExportOptions, setSelectedExportOptions] = useState(TF_EXPORT_DEFAULT_SELECT_OPTIONS);

  const sortFilter = (selectedOptions) => {
    const orderMap = new Map(TF_SORTED_OPTIONS.map((value, index) => [value, index]));

    return [...selectedOptions]
      .sort((a, b) => {
        const indexA = orderMap.get(a.value);
        const indexB = orderMap.get(b.value);

        if (indexA === undefined && indexB === undefined) return 0;
        if (indexA === undefined) return 1;
        if (indexB === undefined) return -1;

        return indexA - indexB;
      })
      .map((o) => o.value);
  };

  const handleOnExport = async (selectedOptions) => {   
    setIsLoading(true);
    try {
      const res = await talentFinderApi.requestDataExport(
        {
          ...filter,
          filter_search_result: talentSearchResult,
          keyword,
          export_sections: sortFilter(selectedOptions),
        },
        role
      );
      if (res.status === 200) {
        setShowExporting(true);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Spin spinning={isLoading}>
      <TalentFinderExportOption
        selectedExportOptions={selectedExportOptions}
        setSelectedExportOptions={setSelectedExportOptions}
        handleOnExport={handleOnExport}
        disabled={!permissions.includes(PERMISSION.TALENT_EXPORT) || !totalData || isLoading}
        filter={filter}
      />
    </Spin>
  );
};

TalentExport.propTypes = {
  filter: PropTypes.object,
  keyword: PropTypes.string,
  role: PropTypes.object,
  totalData: PropTypes.number,
  setShowExporting: PropTypes.func,
};
export default TalentExport;
